<template>
    <div class="page-container">
        <!-- 企业简介 -->
        <div class="smart-container">
            <div class="matrix-header">
                <h2>企业简介</h2>
            </div>
            <div class="Introduction">
                <p class="Introduction-title">
                    北京云智轩科技有限公司自 2021 年启航，始终深耕农业智能化领域，以设备与系统的研发创新为核心驱动力，矢志为农业生产勾勒全方位智能化的崭新蓝图。
                    <br />
                    2023 年，云智轩科技匠心推出 “芯棚到家” 品牌，精准锚定设施农业智能化赛道。公司麾下的专业研发团队，秉持着对农业发展趋势的深刻洞察，深度调研用户需求，在创新与优化的道路上永不止步。
                    <br />
                    如今，“芯棚到家” 品牌的产品已成功打入全国多个省市的农业种植区域，累计服务对象囊括数千家农业企业、种植大户以及合作社。凭借过硬的产品品质和贴心的服务，赢得了市场的广泛赞誉与信赖。
                </p>
            </div>
        </div>

        <!-- 产品专利 -->
        <div class="smart-container">
            <div class="matrix-header">
                <h2>产品专利</h2>
            </div>
            <div class="smart-wrapper">
                <el-row class="smart-row" :gutter="10">
                    <el-col :span="6" class="smart-item" v-for="(item, index) in smart" :key="index">
                        <div class="smart-image-container">
                            <img :src="item.image" class="smart-image" :alt="'产品专利' + (index + 1)">
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>

        <!-- 软件著作权 -->
        <div class="smart-container">
            <div class="matrix-header">
                <h2>软件著作权</h2>
            </div>
            <div class="smart-wrapper">
                <el-row class="smart-row" :gutter="10">
                    <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8" :xxl="8" class="smart-item"
                        v-for="(item, index) in copyright" :key="index">
                        <div class="smart-image-container">
                            <img :src="item.image" class="smart-image" :alt="'软件著作权' + (index + 1)">
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MainHomepage',
    data() {
        return {
            smart: [
                { image: require('@/assets/images/Mainabout/four.png') },
                { image: require('@/assets/images/Mainabout/five.png') },
                { image: require('@/assets/images/Mainabout/two.png') },
                { image: require('@/assets/images/Mainabout/three.png') },
                { image: require('@/assets/images/Mainabout/one.png') },
                { image: require('@/assets/images/Mainabout/six.png') },
                { image: require('@/assets/images/Mainabout/eight.png') },
                { image: require('@/assets/images/Mainabout/nine.png') },
            ],
            copyright: [
                { image: require('@/assets/images/Mainabout/copyright-one.png') },
                { image: require('@/assets/images/Mainabout/copyright-two.png') },
                { image: require('@/assets/images/Mainabout/copyright-three.png') },
            ]
        }
    },
}
</script>

<style scoped>
.page-container {
    width: 100%;
    background-color: rgba(216, 216, 216, 0.2);
    overflow-x: hidden;
}

/* 企业简介 */
.smart-container {
    width: 100%;
    max-width: 1920px;
    padding: 10px 20px 60px;
    box-sizing: border-box;
    margin: 0 auto;
}

.matrix-header {
    text-align: center;
    margin-bottom: 64px;
    padding-top: 30px;
}

.matrix-header h2 {
    text-align: center;
    margin-bottom: 16px;
    font-family: 'Alibaba_PuHuiTi_2.0_55_Regular_55_Regular';
    font-size: 32px;
    font-weight: 600;
    line-height: 36px;
    color: #111827;
}

.Introduction {
    width: 100%;
    max-width: 1360px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
}

.Introduction-title {
    font-family: 'Alibaba_PuHuiTi_2.0_55_Regular_55_Regular';
    font-size: 24px;
    font-weight: 350;
    line-height: 40px;
    color: #232323;
    letter-spacing: 1px;
}

/* 产品专利和软件著作权通用样式 */
.smart-wrapper {
    width: 100%;
    margin: 0 auto;
}

.smart-row {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    box-sizing: border-box;
    margin: 0 !important;
}

.smart-item {
    box-sizing: border-box;
    margin-bottom: 30px;
}

.smart-image-container {
    width: 100%;
    height: 280px;
    border-radius: 0.5rem;
    overflow: hidden;
    margin-bottom: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ffffff;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.smart-image {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    padding: 20px;
}

/* 手机设备样式 (小于768px) */
@media (max-width: 767px) {
    .matrix-header {
        margin-bottom: 40px;
    }

    .matrix-header h2 {
        font-size: 24px;
        line-height: 32px;
    }

    .Introduction-title {
        font-size: 16px;
        line-height: 28px;
        letter-spacing: 0.5px;
    }

    .smart-image-container {
        height: 180px;
    }
}

/* 平板设备样式 (768px - 1023px) */
@media (min-width: 768px) and (max-width: 1023px) {
    .matrix-header h2 {
        font-size: 28px;
        line-height: 34px;
    }

    .Introduction-title {
        font-size: 20px;
        line-height: 34px;
    }

    .smart-image-container {
        height: 220px;
    }
}

/* 大屏幕设备样式 (2560px - 3839px) */
@media (min-width: 2560px) and (max-width: 3839px) {
    .smart-container {
        max-width: 2400px;
        padding: 20px 30px 80px;
    }

    .matrix-header {
        margin-bottom: 80px;
    }

    .matrix-header h2 {
        font-size: 42px;
        line-height: 48px;
    }

    .Introduction-title {
        font-size: 30px;
        line-height: 50px;
        letter-spacing: 1.2px;
    }

    .smart-image-container {
        height: 360px;
    }
}

/* 超大型屏幕设备样式 (3840px及以上) */
@media (min-width: 3840px) {
    .smart-container {
        max-width: 3200px;
        padding: 20px 40px 100px;
    }

    .matrix-header {
        margin-bottom: 100px;
    }

    .matrix-header h2 {
        font-size: 52px;
        line-height: 60px;
    }

    .Introduction-title {
        font-size: 36px;
        line-height: 60px;
        letter-spacing: 1.5px;
    }

    .smart-image-container {
        height: 450px;
    }
}
</style>